
import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { IconButton } from '@material-ui/core';

export default function CheckIcon(props) {
    const { style, isChecked, onClick, disabled } = props;
    const classes = useStyles(props)()

    return(
        <IconButton disabled={disabled} onClick={onClick} style={{position:"relative", display:"flex", justifyContent:"center", alignItems:"center" }}>
            <svg className={classes.container}  style={style} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="1" width="18" height="18" rx="5" stroke="#192A7F" strokeWidth="2"/>
            </svg>
            {
                isChecked &&
                <svg style={{position:"absolute"}} width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="10" height="10" rx="3" fill="#2196C0"/>
                </svg>
            }
        </IconButton>
    )
}


const useStyles = props => makeStyles((theme) => ({
    container:{
        '& path': {
            fill: props.color,
            width: props.width,
         },
    }
}));